import { lazy } from "react"
import CommonLayout from "layout/CommonLayout"
import Loadable from "@/components/building-blocks/controls/Loadable"
import GuestGuard from "@/components/building-blocks/routes/GuestGuard"
import { AppGuestRoutes } from "@/config/routes"
import { OptionalRouterParam, RequiredRouterParam } from "@/components/building-blocks/routes/RouteParams"

const LoginPage = Loadable(lazy(() => import("@/pages/auth/LoginPage")))
const PasswordRecoverPage = Loadable(lazy(() => import("@/pages/auth/PasswordRecoverPage")))

// ==============================|| AUTH ROUTES ||============================== //

const GuestRoutes = {
    element: (
        <GuestGuard>
            <CommonLayout />
        </GuestGuard>
    ),
    children: [
        // {
        //     path: AppGuestRoutes.landing.path,
        //     element: <LandingPage />,
        // },
        {
            path: AppGuestRoutes.login.path,
            element: <LoginPage />,
        },
        {
            path: AppGuestRoutes.passwordRecover.path,
            element: (
                <OptionalRouterParam paramId="token">
                    {(param) => <PasswordRecoverPage token={param} />}
                </OptionalRouterParam>
            ),
            children: [
                {
                    path: AppGuestRoutes.passwordRecover.children.verify.path,
                    element: (
                        <RequiredRouterParam paramId="token">
                            {(param) => <PasswordRecoverPage token={param} />}
                        </RequiredRouterParam>
                    ),
                },
            ],
        },
    ],
}

export default GuestRoutes
